export enum PriceTypeEnum {
    IssuePrice = 1,
    RedemptionPrice = 2,
    PenalRedemptionPrice = 3,
    NetAssetValue = 4,
    BidPrice = 5,
}
